

export class Card {
    public id: number;
    public type: string;
    public uuid: string;
    public pin: string;
    public active: boolean;
    public description: string;

    constructor(
        id: number, 
        type: string, 
        uuid: string, 
        pin: string,
        active: boolean,
        description: string,
        ) {
        this.id = id;
        this.type = type;
        this.uuid = uuid;
        this.pin = pin;
        this.active = active;
        this.description = description;
    }
}